const STORAGE_KEY = 'bg_read_article_ids'

function loadIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed.map(String) : []
  } catch (e) {
    return []
  }
}

function saveIds(ids) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(-200)))
}

export function getReadArticleIds() {
  return loadIds()
}

export function markArticleRead(articleId) {
  if (articleId == null) return
  const id = String(articleId)
  const ids = loadIds()
  if (!ids.includes(id)) {
    ids.push(id)
    saveIds(ids)
  }
}

export function markArticlesRead(articleIds) {
  if (!articleIds || !articleIds.length) return
  const ids = loadIds()
  articleIds.forEach(item => {
    const id = String(item)
    if (!ids.includes(id)) ids.push(id)
  })
  saveIds(ids)
}

export function countUnread(articles) {
  if (!articles || !articles.length) return 0
  const readSet = new Set(loadIds())
  return articles.filter(a => a && a.articleId != null && !readSet.has(String(a.articleId))).length
}
